module.exports = __webpack_public_path__ + "static/media/3.d582efb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/3.png
// module id = 689
// module chunks = 0